import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { filter, map, shareReplay, tap } from 'rxjs/operators';
import { ProjectDto } from "../../api/models/project-dto";
import { ProjectsApiService } from "../../api/services/projects-api.service";
import { CitiMenu, OcfaMenu, OcfaUkraineMenu, PdiMenu, TgMenu } from '../../constants/projects-menus';
import { ProjectMenus } from '../../contracts/project-menu';
import { TranslateService } from "@ngx-translate/core";

@Injectable({
    providedIn: 'root'
})
export class ApplicationService {
    private projects$ = this.projectsApiService.projectsFindAll().pipe(filter(t => !!t), map(data => data.items), shareReplay({
        refCount: false,
        bufferSize: 1
    }));
    readonly project = new BehaviorSubject<ProjectDto | null>(null);
    readonly projectMenu$ = this.project.pipe(filter(project => !!project), map(project => this.getMenu(project)), shareReplay({
        refCount: true,
        bufferSize: 1
    }));

    readonly darkThemeEnabled$ = new Subject<boolean>();

    constructor(private projectsApiService: ProjectsApiService,
                private translateService: TranslateService
    ) { }

    setActiveProject(id: number): Observable<boolean> {
        return this.projects$.pipe(map(projects => projects.find(t => t.id === id)), tap(project => !!project && this.project.next(project)), map(project => !!project));
    }

    changeLanguage(isChange) {
        this.translateService.use(isChange ?  'ua' : 'ru')
    }

    resetProject(): void {
        this.project.next(null);
    }

    private getMenu(project: ProjectDto): ProjectMenus {
        //TODO: Use workflow field
        switch (project.name) {
            case 'ocfa-ukraine':
            case 'ocfa-kyrgyzstan':
                return OcfaUkraineMenu;
            case 'ocfa-kazakhstan':
            case 'ocfa-moldova':
            case 'ocfa-russia':
            case 'ocfa-uzbekistan':
                return OcfaMenu;
            case 'tg-kg':
            case 'tg':
            case 'ibbs':
            case 'tls-ibbs':
            case 'rds-ibbs':
                return TgMenu;
            case 'pdi':
            case 'pdi-msm':
            case 'pdi-tg':
            case 'pdi-sw':
                return PdiMenu;
            case 'citi':
                return CitiMenu;
        }

        console.error(`Project menu for project with name ${ project.name } could be not found`);
        return [];
    }
}
